module.exports = __webpack_public_path__ + "img/nbremote2.12aec545.jpg";